/* eslint-disable */
import { message, Modal } from "antd";
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import qs from "qs";
import store from "@/store/index";
import { EActionType } from "@/store/globle/types";
import { setCookie } from "@/utils/cookies";

const ENV = ENV_CUSTOM;

axios.defaults.withCredentials = true;
if (ENV === "development") {
  setCookie(
    "authorization",
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2NvdW50Ijoid19jaGVuamlhbGluIiwiZW1haWwiOiIiLCJuYW1lIjoi6ZmI5L2z6ZyWIiwid29ya2NvZGUiOiJXMDA5MDgxIiwidGVhY2hlcl9pZCI6MCwiY291bnNlbG9yX2lkIjowLCJ0ZWFjaGVyX3R5cGUiOjAsImRlcGFydG1lbnQiOjQsImV4cCI6MTc2NjAyODg3NywiaXNzIjoieGl3YW5nIn0.Fso43to8ygJWpvmd5k4OhAYx6FHkGlR7QSVL0EVcHBc"
  );
  localStorage.setItem(
    "intelli_userInfo",
    '{"account":"w_chenjialin","counselor_id":1090627,"name":"陈佳霖","teacher_id":84193,"teacher_type":2,"workcode":"W009081"}'

    // '{"account":"w_haoankang","counselor_id":0,"name":"郝安康","teacher_id":1,"teacher_type":3,"workcode":"W006287"}'
  );
}
// A872282410
export const loginUrl =
  ENV === "test"
    ? `https://sso.saash.vdyoo.com/portal/login/A572282345`
    : `https://sso.saash.vdyoo.com/portal/login/A872282410`;

export interface BaseResponse<T = any> {
  res: {
    source_url: string;
    introduction: string;
    timestamp: number;
    sign: string;
  };
  code?: number;
  msg: string;
  data: T;
}
export interface cancelResponse<V = any> {
  cancel(): void;
  data: Promise<AxiosResponse<BaseResponse<V>>>;
}

const ErrorDic: {
  [key: number]: string;
} = {
  400: "错误的请求",
  401: "未授权，请登录",
  403: "服务器拒绝访问",
  404: "服务器未找到资源",
  408: "请求超时",
  500: "服务器内部错误",
  502: "网关错误",
  503: "服务不可用",
  504: "网关超时",
};

class ApiError extends Error {
  constructor(public code = 0, msg = "") {
    super(msg);
    this.name = this.constructor.name;
    message.error(msg);
  }

  static createBuiltInApiError(statusCode: number) {
    const msg = ErrorDic[statusCode];
    if (msg) {
      return new ApiError(statusCode, msg);
    } else {
      return new ApiError(statusCode, "抱歉出错了");
    }
  }
}

export enum RequestContentType {
  URL_ENCODE = 0,
  JSON = 1,
  FORM_DATA = 2,
  FORM_URLENCODED = 3,
}

interface MindRequestConfig {
  withCredentials?: boolean;
  contentType?: RequestContentType;
  signal?: AbortSignal;
  loading?: boolean;
}
const formUrlencoded = "application/x-www-form-urlencoded";
const formDataContentType = "multipart/form-data";
const defaultRequestConfig: AxiosRequestConfig = {
  timeout: 20000,
  headers: {},
};

function getInstanceConfig(
  instanceConfig: AxiosRequestConfig
): AxiosRequestConfig {
  const { timeout, baseURL, headers } = instanceConfig;
  let mergedHeaders = defaultRequestConfig.headers;
  if (instanceConfig.headers) {
    mergedHeaders = Object.assign(
      {},
      defaultRequestConfig.headers,
      instanceConfig.headers
    );
  }
  return Object.assign({}, defaultRequestConfig, {
    timeout,
    baseURL,
    mergedHeaders,
  });
}

type InterceptorFulfill<V> = (value: V) => V | Promise<V>;
type InterceptorReject = (error: any) => any;

export class AjaxRequest {
  private _axiosInstanceConfig: AxiosRequestConfig;
  public _ajax: AxiosInstance;
  private _concurrencyMap: Map<string, Promise<AxiosResponse<any>>>;

  constructor(instanceConfig: AxiosRequestConfig = {}, standard = true) {
    this._concurrencyMap = new Map();

    this._axiosInstanceConfig = getInstanceConfig(instanceConfig);
    this._ajax = axios.create(this._axiosInstanceConfig);

    this._ajax.interceptors.response.use(
      (res: any) => {
        store.dispatch({ type: EActionType.LOADING, loading: false });
        try {
          if (res && res.status === 200) {
            if (res.data) {
              const { code, msg } = res.data;
              if (code !== 0) {
                console.error(res);
                if (code === 1) {
                  Modal.info({
                    title: "温馨提示",
                    content: msg,
                    onOk: () => {
                      localStorage.removeItem("intelli_userInfo");
                      // localStorage.removeItem("intelli_token");
                      // 重定向到集团登录页面
                      window.location.href =
                        "https://sso.saash.vdyoo.com/sso/logout?path=" +
                        loginUrl;
                    },
                  });
                } else if (standard) {
                  message.error(msg);
                }
              }
              return res;
            } else {
              throw new ApiError(200, "接口返回数据为空");
            }
          } else if (res && res.status === 401) {
            Modal.info({
              title: "温馨提示",
              content: res.data.msg,
              onOk: () => {
                localStorage.removeItem("intelli_userInfo");
                // localStorage.removeItem("intelli_token");
                // 重定向到集团登录页面
                window.location.href =
                  "https://sso.saash.vdyoo.com/sso/logout?path=" + loginUrl;
                // localStorage.removeItem('userInfo');
                // localStorage.removeItem('hasLogin');
                // window.location.href = 'https://sso.saash.vdyoo.com/sso/logout?path=' + loginUrl;
              },
            });
          } else {
            throw new ApiError(0, "抱歉出错了");
          }
        } catch (err) {
          throw err;
        }
      },
      (error) => {
        let errorInstance = null;
        if (error.response) {
          errorInstance = ApiError.createBuiltInApiError(error.response.status);
        } else {
          errorInstance = new ApiError(0, "抱歉出错了");
        }
        store.dispatch({ type: EActionType.LOADING, loading: false });
        // throw error
        return Promise.reject(errorInstance);
      }
    );
  }

  registerRequestInterceptor(
    // fulfilled: InterceptorFulfill<AxiosRequestConfig>,
    fulfilled,
    rejected: InterceptorReject
  ) {
    if (fulfilled) {
      this._ajax.interceptors.request.use(fulfilled, rejected);
    }
  }

  registerResponseInterceptor<V>(
    // fulfilled: InterceptorFulfill<AxiosResponse<V>>,
    fulfilled,
    rejected: InterceptorReject
  ) {
    if (fulfilled) {
      this._ajax.interceptors.response.use(fulfilled, rejected);
    }
  }

  changeAxiosHeaderCommon(headerText: string, value: string): void {
    if (headerText !== "") {
      axios.defaults.headers[headerText] = value;
    }
  }

  async noRepeatGet<V extends BaseResponse>(
    url: string,
    params: any,
    { withCredentials = true }: MindRequestConfig = {}
  ): Promise<AxiosResponse<V>> {
    const resultParams = params || {};
    resultParams.ts = +new Date();
    const key = qs.stringify({
      url,
      params,
    });
    if (this._concurrencyMap.has(key)) {
      const result = (await this._concurrencyMap.get(key)) as AxiosResponse<V>;
      if (result.data.code !== 0) {
        throw new ApiError(result.data.code, result.data.msg);
      } else {
        return result;
      }
    } else {
      const pro = this._ajax.get<V, AxiosResponse<V>>(url, {
        params: resultParams,
        withCredentials,
      });
      this._concurrencyMap.set(key, pro);
      const result = await pro;
      this._concurrencyMap.delete(key);
      return result;
    }
  }

  async get<V extends BaseResponse>(
    url: string,
    params: any,
    { withCredentials = true, loading = true }: MindRequestConfig = {}
  ): Promise<AxiosResponse<V>> {
    loading && store.dispatch({ type: EActionType.LOADING, loading: true });
    const resultParams = params || {};
    const httpHeader: any = {};
    return this._ajax.get<V, AxiosResponse<V>>(url, {
      params: resultParams,
      withCredentials,
      headers: httpHeader,
    });
  }

  async post<V extends BaseResponse>(
    url: string,
    params: any,
    {
      withCredentials = true,
      contentType = RequestContentType.JSON,
      loading = true,
    }: MindRequestConfig = {}
  ): Promise<AxiosResponse<V>> {
    loading && store.dispatch({ type: EActionType.LOADING, loading: true });
    let resultParams = params;
    if (contentType === RequestContentType.URL_ENCODE) {
      resultParams = qs.stringify(resultParams);
    }
    const httpHeader: any = {};
    if (contentType === RequestContentType.FORM_DATA) {
      httpHeader["content-type"] = formDataContentType;
    }
    if (contentType === RequestContentType.FORM_URLENCODED) {
      httpHeader["Content-Type"] = formUrlencoded;
      resultParams = qs.stringify(params);
    }
    const result = await this._ajax.post<V, AxiosResponse<V>>(
      url,
      resultParams,
      {
        withCredentials,
        headers: httpHeader,
      }
    );
    return result;
  }

  async put<V extends BaseResponse>(
    url: string,
    params: any,
    { withCredentials = true, loading = true }: MindRequestConfig = {}
  ): Promise<AxiosResponse<V>> {
    loading && store.dispatch({ type: EActionType.LOADING, loading: true });
    const resultParams = params || {};
    const httpHeader: any = {};
    return this._ajax.put<V, AxiosResponse<V>>(url, resultParams, {
      withCredentials,
      headers: httpHeader,
    });
  }

  // 取消单次请求
  cancelSingleRequest<V extends BaseResponse>(
    url: string,
    params: any,
    { withCredentials = true }: MindRequestConfig = {}
  ): cancelResponse<V> {
    const controller = new AbortController();
    const result = this.get<BaseResponse<V>>(url, params, {
      withCredentials: true,
      signal: controller.signal,
    });
    return {
      cancel: controller.abort,
      data: result,
    };
  }

  // 取消多次请求
  cancelMoreRequest() {
    let controller: AbortController | null = null;
    return <V extends BaseResponse>(
      url: string,
      params: any,
      { withCredentials = true }: MindRequestConfig = {}
    ): cancelResponse<V> => {
      controller = controller || new AbortController();
      const result = this.get<BaseResponse<V>>(url, params, {
        withCredentials: true,
        signal: controller.signal,
      });
      return {
        cancel: controller.abort,
        data: result,
      };
    };
  }
}

const URL_CONFIG = {
  development: "/api",
  production: "https://scmapi.xiwang.com/tikuapi/teacher",
  test: "https://scmapitest.xiwang.com/tikuapi/teacher",
};
const URL = URL_CONFIG[ENV];

// 创建的几个实例
export default new AjaxRequest(
  {
    baseURL: URL,
  },
  true
);

// 不标准
export const notStandardAjax = new AjaxRequest(
  {
    baseURL: URL,
  },
  false
);
